import { SITE_URL } from './siteUrl';

export const SITE_NAME = 'SecureOneLabs';
const DEFAULT_OG_IMAGE = '/og-default.png';

function absoluteUrl(pathOrUrl) {
  if ((/^https?:\/\//).test(pathOrUrl)) {
    return pathOrUrl;
  }
  return `${SITE_URL}${pathOrUrl}`;
}

/**
 * Builds a TanStack Router `head()` return value: unique <title>, meta
 * description, absolute canonical, and Open Graph / Twitter card tags.
 *
 * @param {Object} params
 * @param {string} params.title - Page title, WITHOUT the site suffix (added here).
 * @param {string} params.description - 140-160 char meta description.
 * @param {string} params.path - Route path, e.g. '/platform/grc'.
 * @param {string} [params.image] - Absolute URL or root-relative path to the OG/Twitter image.
 * @param {string} [params.type] - Open Graph type, defaults to 'website'.
 */
export function buildSeoHead({ title, description, path, image = DEFAULT_OG_IMAGE, type = 'website' }) {
  const fullTitle = `${title} · ${SITE_NAME}`;
  const canonical = absoluteUrl(path);
  const imageUrl = absoluteUrl(image);

  return {
    meta: [
      { title: fullTitle },
      { name: 'description', content: description },
      { property: 'og:title', content: fullTitle },
      { property: 'og:description', content: description },
      { property: 'og:url', content: canonical },
      { property: 'og:type', content: type },
      { property: 'og:site_name', content: SITE_NAME },
      { property: 'og:image', content: imageUrl },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: fullTitle },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: imageUrl },
    ],
    links: [{ rel: 'canonical', href: canonical }],
  };
}
